exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.view-desc {\r\n    color: white;\r\n}\r\n\r\ni span {\t\r\n\tdisplay:none;\r\n\tcolor:#fff;\r\n\tbackground:#d86f01;\r\n\tpadding:20px;\r\n\tborder-radius:4px;\r\n\t-moz-border-radius:4px;\r\n\t-webkit-border-radius:4px;\r\n\ttext-align:center;\r\n    position: absolute;\r\n\tz-index:10;\r\n    max-width: 600px;\r\n    line-height: 18px;\r\n    font-size: 16px;\r\n}\r\n\r\ni { display: inline-block; }\r\n\r\ni:hover span{ display:block; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-view-desc-bubble/usc-view-desc-bubble.component.css
// module id = ../../../../../src/app/components/usc-store/usc-view-desc-bubble/usc-view-desc-bubble.component.css
// module chunks = main